/** @file A local image offset turned counter-clockwise as seen on screen (y down). */
import { degToRad } from '@zilo/pose3d-math/angle/degToRad';

/** `[x cos + y sin, -x sin + y cos]` for `deg` counter-clockwise. */
export function rotateLocal(x: number, y: number, deg: number): [number, number] {
  const a = degToRad(deg);
  const c = Math.cos(a);
  const s = Math.sin(a);
  return [x * c + y * s, -x * s + y * c];
}
